module.exports = __webpack_public_path__ + "static/media/nodejs.c502658a.png";